/** Jednokreskowe ikony 24×24 przeniesione z prototypu (`ICONS` z b00k-data.js). */
export const ICON_PATHS = {
  bed: "M3 19v-8a2 2 0 012-2h14a2 2 0 012 2v8M3 16h18M3 19v1M21 19v1M7 9V7a2 2 0 012-2h6a2 2 0 012 2v2",
  car: "M5 11l1.5-4.5A2 2 0 018.4 5h7.2a2 2 0 011.9 1.5L19 11M4 11h16a1 1 0 011 1v4h-2.5M3 16v-4a1 1 0 011-1M9.5 16h5M6.5 16a1.5 1.5 0 103 0 1.5 1.5 0 10-3 0M14.5 16a1.5 1.5 0 103 0 1.5 1.5 0 10-3 0",
  ticket: "M3 9a2 2 0 012-2h14a2 2 0 012 2v1a2 2 0 100 4v1a2 2 0 01-2 2H5a2 2 0 01-2-2v-1a2 2 0 100-4zM14 7v2M14 11v2M14 15v2",
  scissors: "M6 9a3 3 0 100-6 3 3 0 000 6zM6 21a3 3 0 100-6 3 3 0 000 6zM20 4L8.1 15.9M14.5 14.5L20 20M8.1 8.1L12 12",
  sparkles: "M12 3l1.9 4.6 4.6 1.9-4.6 1.9L12 16l-1.9-4.6L5.5 9.5l4.6-1.9zM19 15l.8 2 2 .8-2 .8-.8 2-.8-2-2-.8 2-.8z",
  med: "M12 3a9 9 0 100 18 9 9 0 000-18M12 8v8M8 12h8",
  wrench: "M14.7 6.3a4.5 4.5 0 00-6 6L3 18l3 3 5.7-5.7a4.5 4.5 0 006-6L14 13l-3-3z",
  book: "M4 19.5A2.5 2.5 0 016.5 17H20M4 19.5A2.5 2.5 0 006.5 22H20V2H6.5A2.5 2.5 0 004 4.5v15zM9 7h7M9 11h5",
  plus: "M12 5v14M5 12h14",
  clock: "M12 3a9 9 0 100 18 9 9 0 000-18M12 8v4l3 2",
  lock: "M6 11V8a6 6 0 0112 0v3M5 11h14v9H5zM12 15v2",
  user: "M12 11a4 4 0 100-8 4 4 0 000 8M4 21v-1a7 7 0 0114 0v1",
  calendar: "M4 6a2 2 0 012-2h12a2 2 0 012 2v13H4zM4 10h16M8 3v3M16 3v3",
  chat: "M21 12a8 8 0 01-8 8H4l2-3a8 8 0 1115-5zM8.5 12h.01M12 12h.01M15.5 12h.01",
  check: "M4 12l5 5L20 6",
  shift: "M12 3a9 9 0 109 9M12 8v4l3 2M21 3v4h-4",
  note: "M5 4h11l3 3v13H5zM9 9h6M9 13h6",
  cancel: "M12 3a9 9 0 100 18 9 9 0 000-18M8 8l8 8",
  phone: "M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.5 19.5 0 01-6-6A19.79 19.79 0 012.12 4.18 2 2 0 014.11 2h3a2 2 0 012 1.72c.13.96.36 1.9.7 2.81a2 2 0 01-.45 2.11L8.09 9.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.91.34 1.85.57 2.81.7A2 2 0 0122 16.92z",
  mail: "M2 6a2 2 0 012-2h16a2 2 0 012 2v12a2 2 0 01-2 2H4a2 2 0 01-2-2zM22 7l-10 6L2 7",
} as const;

export type IconName = keyof typeof ICON_PATHS;

/** Ikony kategorii — te same, których używa landing i widok klienta. */
export const CATEGORY_ICON: Record<string, IconName> = {
  rooms: "bed",
  cars: "car",
  attr: "ticket",
  hair: "scissors",
  beauty: "sparkles",
  med: "med",
  workshop: "wrench",
  tutoring: "book",
  other: "plus",
};

export function Icon({ name, size = 24, className }: { name: IconName; size?: number; className?: string }) {
  return (
    <svg
      viewBox="0 0 24 24"
      width={size}
      height={size}
      fill="none"
      stroke="currentColor"
      strokeWidth={1.8}
      strokeLinecap="round"
      strokeLinejoin="round"
      style={{ display: "block", flex: "none" }}
      className={className}
      aria-hidden="true"
    >
      <path d={ICON_PATHS[name]} />
    </svg>
  );
}

/** Logo b00k — trzy przecinające się kreski (symbol zbioru pustego). */
export function Logo({ size = 26, color = "var(--accent)" }: { size?: number; color?: string }) {
  return (
    <svg viewBox="0 0 40 40" width={size} height={size} style={{ overflow: "visible" }} aria-hidden="true">
      <line x1="20" y1="6.5" x2="20" y2="33.5" stroke={color} strokeWidth="3.8" strokeLinecap="round" />
      <line x1="8.3" y1="13.25" x2="31.7" y2="26.75" stroke={color} strokeWidth="3.8" strokeLinecap="round" />
      <line x1="31.7" y1="13.25" x2="8.3" y2="26.75" stroke={color} strokeWidth="3.8" strokeLinecap="round" />
    </svg>
  );
}

/** Kropka koloru kategorii / klienta. */
export function Dot({ color, large }: { color: string; large?: boolean }) {
  return <span className={large ? "ui-dot ui-dot--lg" : "ui-dot"} style={{ background: color }} />;
}
